var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9999 4.10781L21.8921 0L18.7606 3.13289L22.8684 7.2407L25.9999 4.10781ZM10.9544 19.1533H6.84658V15.0455L16.8244 5.06767L20.9323 9.17547L10.9544 19.1533ZM7.06269 23.2611H21.9083V14.1308L24.6468 11.3923V23.2611C24.6468 23.9874 24.3583 24.684 23.8447 25.1976C23.3312 25.7111 22.6346 25.9997 21.9083 25.9997H2.73854C1.22823 25.9997 0 24.7728 0 23.2611V4.09136C0 2.57969 1.22823 1.35282 2.73854 1.35282H14.8525L12.1139 4.09136H2.73854V23.2611H6.81759C6.8397 23.2618 6.86151 23.2649 6.88315 23.268C6.90707 23.2714 6.9308 23.2748 6.95452 23.2748C6.97232 23.2748 6.99046 23.2714 7.0086 23.268C7.02675 23.2646 7.04489 23.2611 7.06269 23.2611Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNote);
export default __webpack_public_path__ + "static/media/edit_note.fe8958031d1990f27b90b10c19915010.svg";
export { ForwardRef as ReactComponent };